import { render } from "./Escalation.vue?vue&type=template&id=52dbf6f5"
import script from "./Escalation.vue?vue&type=script&lang=js"
export * from "./Escalation.vue?vue&type=script&lang=js"

import "./Escalation.vue?vue&type=style&index=0&id=52dbf6f5&lang=scss"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__